export default __webpack_public_path__ + "static/media/join-success.86372f15.png";